import config from "../../config";
import Header from "../../components/Header";
import Head from "next/head";

import CategoryCard from "../../components/CategoryCard";
import Footer from "../../components/Footer";
import React from "react";
import HeaderExtension from "../../components/HeaderExtension";

export default function Category({ categories }) {
  return (
    <div className="bg-gray-100  absolute w-full  min-h-screen">
      <Head>
        <title>Automate.video | Browse Categories</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />
      <HeaderExtension title={"Browse Categories"} />
      <div className="container relative px-2 mx-auto mt-6 w-full mb-60">
        <div className="flex flex-row items-center">
          <div className="flex flex-col flex-grow"> </div>
          <div className="flex flex-col flex-initial flex-grow-0 mx-auto  ">
            <div className="inline-flex flex-row flex-auto flex-wrap gap-3 mt-2 justify-center">
              {categories
                ? categories.map((c) => {
                    return <CategoryCard {...c} key={c.id} />;
                  })
                : null}
              <CategoryCard url="/directory/all" id="all" text="All Videos" key="all" />
              <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
              <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
              <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
              <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
            </div>
          </div>
          <div className="flex flex-col flex-grow"> </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getStaticProps({ params }) {
  let categories = [];

  const res = await fetch(`${config.socketIo}/api/getAllFeaturedCategories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  let featuredCategories = await res.json();
  /*
  let topIndex = featuredCategories.indexOf("top");
  if (topIndex !== 0)
    [featuredCategories[0], featuredCategories[topIndex]] = [featuredCategories[topIndex], featuredCategories[0]];
*/
  for (let f of featuredCategories) {
    let category = {
      id: f.path,
      url: "/browse/" + f.path,
      text: f.name.split(" ").map(capitalize).join(" "),
      imageUrl: "/images/business.jpg",
    };

    categories.push(category);
  }

  return { props: { categories: categories } };
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
